import { render, staticRenderFns } from "./settingPurview.vue?vue&type=template&id=330872f0&scoped=true&"
import script from "./settingPurview.vue?vue&type=script&lang=js&"
export * from "./settingPurview.vue?vue&type=script&lang=js&"
import style0 from "./settingPurview.vue?vue&type=style&index=0&id=330872f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330872f0",
  null
  
)

export default component.exports